import styled from '@emotion/styled/macro';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import { useWindowWide } from '../../utils/common_functions';

const ProjectCard = ({ image, content, bg, loading }) => {
  const largeScreen = useWindowWide(998);
  return (
    <Card
      loading={loading}
      style={{ textAlign: 'left', width: '100%', height: largeScreen ? '100%' : 'fit-content' }}>
      <Wrapper>
        <ImageWrapper bg={bg}>{image}</ImageWrapper>
        <Box>{content}</Box>
      </Wrapper>
    </Card>
  );
};

export default ProjectCard;

ProjectCard.propTypes = {
  image: PropTypes.element,
  content: PropTypes.element,
  bg: PropTypes.string,
  loading: PropTypes.bool
};

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 50px auto;
  gap: 10px;
  @media (max-width: 600px) {
    display: flex;
  }
`;

const ImageWrapper = styled.div`
  background-color: ${({ bg }) => bg};
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: 16px;
  @media (max-width: 600px) {
    display: none;
  }
`;

const Box = styled.div`
  @media (max-width: 600px) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }
`;
